export const SET_DEFAULT_LISTING = 'SET_DEFAULT_LISTING';
export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';
export const UPDATE_ACTIVE_FAQS = 'UPDATE_ACTIVE_FAQS';
export const UPDATE_ACTIVE_FILTERS = 'UPDATE_ACTIVE_FILTERS';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';